import React, { useEffect, useRef, useState } from 'react';
import type { RefObject } from 'react';

import { twMerge } from 'tailwind-merge';

interface PanelProps {
  isOpen: boolean;
  children?: React.ReactNode | [React.ReactNode];
}

const Collapsible: React.FC<PanelProps> = (props) => {
  const { isOpen, children } = props;

  const [childHeight, setChildHeight] = useState('');

  const ref: RefObject<HTMLDivElement> = useRef(null);

  useEffect(() => {
    const childHeightRaw = ref.current?.clientHeight ?? 0;
    const remHeight = `${childHeightRaw / 4}rem`;
    setChildHeight(remHeight);
  }, []);

  const contentClassNames = twMerge(
    'bg-white w-full overflow-hidden border border-slate300 rounded-b-md',
    'transition-all duration-500',
    !isOpen && 'rounded-md mt-[-1px]',
  );

  return (
    <div
      className={contentClassNames}
      style={{
        borderTopWidth: isOpen ? 1 : 0,
        maxHeight: isOpen ? childHeight : 0,
      }}
    >
      <div className="container px-0" ref={ref}>
        {children}
      </div>
    </div>
  );
};
export default Collapsible;
